module.exports = __webpack_public_path__ + "web/img/jpeg.0ae4c828.png";